export class SessionsService {
    constructor(axios, apiUrl) {
      this.$axios = axios;
      this.apiUrl = apiUrl;
    }

  /**
   * Get session by id
   * @param {} data
   * @returns int
   */
   async getSessionById(id) {
    return await this.$axios.get(this.apiUrl + `Sessions/Session/${id}`).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      console.error(error);
      return undefined;
    });
  }
  
  /**
   * Get session by id
   * @param {} data
   * @returns int
   */
   async createSession(data) {
    return await this.$axios.post(this.apiUrl + `Sessions/Session`).then(function(response) {
        return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }


}